export default function unformatText (text) {
  return text
    .replace(/\\;/gm, ";")
    .replace(/\\,/gm, ",");
}